import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoaderStoreService } from '@shared/services/loader-store.service';
import { finalize } from 'rxjs';

export const httpLoadingInterceptor: HttpInterceptorFn = (req, next) => {
   const SkipLoading = 
  new HttpContextToken<boolean>(() => false);

  const loaderStore = inject(LoaderStoreService);

  if (req.context.get(SkipLoading)) {
    // Pass the request directly to the next handler
    return next(req);
  }

  loaderStore.set('loading', true);
  

  return next(req).pipe(
    finalize(() => {
      loaderStore.set('loading', false);
    })
  );
};
